import { render, staticRenderFns } from "./PurchaseProcedure.vue?vue&type=template&id=72cbf4ac&scoped=true&"
import script from "./PurchaseProcedure.vue?vue&type=script&lang=js&"
export * from "./PurchaseProcedure.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseProcedure.vue?vue&type=style&index=0&id=72cbf4ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cbf4ac",
  null
  
)

export default component.exports